import { useState, useEffect } from "react";
import { obter_paises_by_lang, reqGET } from "../../Utils";
import Hosts from "../../Hosts";
import { getTokenInfo } from "../../UseToken";
import { PieChart, Pie, Cell, Tooltip, Sector } from 'recharts';
import { color } from "../WEBContent/Color";
import { language } from '../WEBContent/Language';
import { set_language } from '../../Utils';
import { Link } from 'react-router-dom';

export default function GraficoPizzaEstadoTarefas(props) {
    const [tasks, setTasks] = useState([]);
    const [taskCounts, setTaskCounts] = useState([]);
    const [hoveredTask, setHoveredTask] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);

    const [lang, set_lang] = useState('pt');
    const [isloading, setLoading] = useState(true);

    const translations = {
        pt: {
            'A Iniciar': 'To Start',
            'Em Execução': 'In Execution',
            'Concluído': 'Completed',
            'Em Revisão': 'Under Review',
            'Em Progresso': 'In Progress',
        },
        en: {
            'To Start': 'A Iniciar',
            'In Execution': 'Em Execução',
            'Completed': 'Concluído',
            'Under Review': 'Em Revisão',
            'In Progress': 'Em Progresso',
        }
    };

    const colors = {
        'A Iniciar': color.corAmarela.rgb3,
        //'To Start': color.corAmarela.rgb3,

        'Em Progresso': color.corNormal.rgb,
        //'In Progress': color.corNormal.rgb,


        'Em Execução': color.corUrgente.rgb,
        //'In Execution': color.corUrgente.rgb,

        'Em Revisão': color.corRoxa.rgb,
        //'Under Review': color.corRoxa.rgb,

        'Concluído': color.corVerde.rgb,
        //'Completed': color.corVerde.rgb,        
    };

    const getColorForState = (state, lang) => {
        let originalState = state;
        if (lang === "en") {
            originalState =
                Object.keys(translations.pt).find(
                    (key) => translations.pt[key] === state
                ) || state;
        }
        return colors[originalState] || "#ccc";
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const entry = payload[0];
            const color = getColorForState(entry.name, lang);

            return (
                <div
                    style={{
                        border: `1px solid ${color}`,
                        backgroundColor: "#fff",
                        padding: "5px 10px",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        gap: "5px",
                    }}
                >
                    <span
                        style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: color,
                            display: "inline-block",
                            borderRadius: "50%",
                        }}
                    ></span>
                    <span style={{ marginRight: "10px" }}>
                        {entry.name}
                    </span>
                    <span>{entry.value}</span>
                </div>
            );
        }
        return null;
    };

    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`);
                if (response?.data) {
                    //console.log('Fetched Tasks:', response.data);
                    setTasks(response.data);
                } else {
                    console.log("Nenhum dado de tasks foi retornado.");
                }
            } catch (error) {
                console.error("Erro ao ir a buscar as tasks:", error);
            }
        };
        fetchTasks();
    }, []);

    useEffect(() => {
        if (tasks.length === 0) return;

        const counts = tasks.reduce((acc, task) => {
            const estado = task.info?.estado?.labelPt;
            if (!estado) return acc;

            acc[estado] = (acc[estado] || 0) + 1;
            return acc;
        }, {});

        const allStates = Object.keys(colors);
        const taskData = allStates.map((estado) => {
            let translatedName = estado;
            if (lang === "en") {
                translatedName = translations.pt[estado] || estado;
            } else if (lang === "pt") {
                translatedName = translations.en[estado] || estado;
            }
            return {
                name: translatedName,
                value: counts[estado] || 0,
            };
        });

        setTaskCounts(taskData);
    }, [tasks, lang]);

    const change_lang = (l) => {
        //set_language(l)
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {

        //set_lang('pt')
        //set_lang_id('1')

        //get_fact_legacy_info()
        //get_fact_legacy_info()

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            console.log("estamos a alterar para", lang)
        }

        setLoading(false)

    }, [props])

    //console.log("Current tasks:", tasks);
    //console.log("Current taskCounts:", taskCounts);

    return (
        <div className="task-distribution">
            <h5
                style={{
                    color: "#333",
                    marginTop: "2%",
                    fontSize: "1.3rem",
                    textAlign: "center",
                }}
            >
                {lang === "en" ? "Task Status 📌" : "Estado das tarefas 📌"}
            </h5>
            <div style={{ position: "relative", display: "flex", justifyContent: "center", cursor: "pointer" }}>
                {taskCounts.length > 0 ? (
                    <Link
                        to={{ pathname: 'intranet_tarefa_list' }}
                        replace
                        style={{ display: 'block', cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
                    >
                        <PieChart width={250} height={250}>
                            <Pie
                                data={taskCounts}
                                cx="50%"
                                cy="50%"
                                innerRadius={70}
                                outerRadius={100}
                                dataKey="value"
                                onMouseEnter={(entry) => setHoveredTask(entry.name)}
                                onMouseLeave={() => setHoveredTask(null)}
                                activeIndex={activeIndex}
                                onMouseOver={(_, index) => setActiveIndex(index)}
                                onMouseOut={() => setActiveIndex(null)}
                                activeShape={(props) => (
                                    <Sector {...props} innerRadius={70} outerRadius={105} fill={props.fill} />
                                )}                        
                            >
                                {taskCounts.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={getColorForState(entry.name, lang)} />
                                ))}
                            </Pie>

                            <Tooltip content={<CustomTooltip />} />
                        </PieChart>
                    </Link>
                ) : (
                    <p style={{ textAlign: "center", fontSize: "10px" }}>
                        {language[lang].no_tasks_scheduled}
                    </p>
                )}

                {hoveredTask && (
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#333",
                        }}
                    >
                        {hoveredTask}
                    </div>
                )}
            </div>

            <div className="legend">
                {taskCounts.map((entry) => (
                    <div key={entry.name} className="legend-item">
                        <span
                            className="legend-color"
                            style={{
                                backgroundColor: getColorForState(
                                    entry.name,
                                    lang
                                ),
                            }}
                        ></span>
                        <span>
                            {entry.name}{/* : {entry.value}*/}
                        </span>
                    </div>
                ))}
            </div>
            <style>{`
                .task-distribution {
                    text-align: center;
                    max-width: 300px;
                    margin: auto;
                }
                .legend {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    margin-top: 20px;
                }
                .legend-item {
                    display: flex;
                    align-items: center;
                    margin: 5px;
                    font-size: 12px;
                }
                .legend-color {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    display: inline-block;
                    margin-right: 5px;
                }
            `}</style>
        </div>
    );
}
